import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ActionCreators from '../actions';
import Schedules from '../components/Schedules';

function mapDispatchToProps(dispatch) {
  return bindActionCreators(ActionCreators, dispatch);
}

function mapStateToProps({ schedules, softwares }) {
  return {
    schedules,
    softwares,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Schedules);
